import { FUNC_NOOP } from '@libs/constants';

import { IFastGame } from '../types/fast-game';

export function createStubFastGame(gameId: string): IFastGame {
  return {
    gameId,
    isLoading: false,
    isFinished: true,
    reject: FUNC_NOOP,
    rematch: FUNC_NOOP,
  };
}
